// extracted by mini-css-extract-plugin
export var banner = "Banner-module--banner--36696";
export var image = "Banner-module--image--e941b";
export var layout = "Banner-module--layout--6d82f";
export var whiteBackground = "Banner-module--white-background--65669";